// Create a new file save-for-later.js and include it in theme.liquid

document.addEventListener('DOMContentLoaded', () => {
  // Save for Later
  document.querySelectorAll('.save-later-btn').forEach(button => {
    button.addEventListener('click', async (e) => {
      const variantId = e.target.dataset.variantId;
      await moveToSavedItems(variantId);
    });
  });

  // Move to Cart from Saved
  document.querySelectorAll('.move-to-cart-btn').forEach(button => {
    button.addEventListener('click', async (e) => {
      const variantId = e.target.dataset.variantId;
      await moveToCart(variantId);
    });
  });
});

async function moveToSavedItems(variantId) {
  // Remove from cart
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 0 })
  });

  // Get item details
  const item = [...cart.items].find(item => item.variant_id === variantId);
  const savedItems = JSON.parse(localStorage.getItem('savedItems') || '[]');
  
  // Add to localStorage
  if (!savedItems.some(i => i.variant_id === variantId)) {
    savedItems.push({
      variant_id: variantId,
      product_title: item.product_title,
      quantity: item.quantity,
      image: item.image,
      price: item.price
    });
    localStorage.setItem('savedItems', JSON.stringify(savedItems));
  }

  location.reload(); // Refresh to update cart
}

async function moveToCart(variantId) {
  const savedItems = JSON.parse(localStorage.getItem('savedItems') || '[]');
  const item = savedItems.find(i => i.variant_id === variantId);

  // Add to cart
  await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: [{
        id: variantId,
        quantity: item.quantity
      }]
    })
  });

  // Remove from saved items
  const updatedItems = savedItems.filter(i => i.variant_id !== variantId);
  localStorage.setItem('savedItems', JSON.stringify(updatedItems));
  location.reload();
}